export class DirectDepositModel {
  constructor(
    public transitNumber: string = '',
    public accountNumber: string = '',
    public bankNumber: string = ''
  ) {}
}
